import {
  Directive,
  HostListener,
  Input,
  OnDestroy
} from '@angular/core';

import { HotkeyMapModel } from './typings/hotkey.map';
import { KEYCODES }       from '../../../core/constants/core.keycodes.constant.ajs';

type HotkeyName = keyof HotkeyMapModel;

// Runs the handler mapped to a key released anywhere on the page; keys released while one waits are ignored.
@Directive({
  selector: '[worHotkey]'
})
export class HotkeyDirective implements OnDestroy {
  @Input() debounce  = 0;
  @Input() worHotkey : HotkeyMapModel = {};

  private _timer : number = null;

  private _keyName ( keyCode : number ) : HotkeyName {
    return ( Object.keys(KEYCODES) as Array<HotkeyName> )
      .find(( name : HotkeyName ) => KEYCODES[name] === keyCode);
  }

  ngOnDestroy () : void {
    window.clearTimeout(this._timer);
  }

  @HostListener('document:keyup', [ '$event' ])
  onKeyup ( event : KeyboardEvent ) : void {
    if ( this._timer !== null ) {
      return;
    }

    this._timer = window.setTimeout(() => {
      const key     = this._keyName(event.keyCode);
      const handler = key && this.worHotkey?.[key];

      this._timer = null;

      if ( handler ) {
        handler(key);
      }
    }, this.debounce);
  }
}
